require('./page-counter.scss');

var PAGE_COUNTER_CLASS = 'page-counter-enabled';

function enablePageCounter($owlCarousel) {
    $owlCarousel.addClass(PAGE_COUNTER_CLASS);
}

function disablePageCounter($owlCarousel) {
    $owlCarousel.removeClass(PAGE_COUNTER_CLASS);
}

module.exports = {
    enablePageCounter: enablePageCounter,
    disablePageCounter: disablePageCounter
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/customization/page-counter.js
// module id = 42
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17